import { httpCreate } from './http';

const http = httpCreate('/srv/corp');

export const corp = {
	getToken() {
		return http.get('/token');
	},
	getconfig4corpwx(url, id = '') {
		return http.post(`/sign/${id}`, { url });
	},
};
